<!-- common component for profile preview: both for registration through company and bloom -->
<template>
  <form v-if="Object.keys(data).length != 0">
    <div class="form-wrap from-wrap-prev">
      <div class="form-sep-block">
        <h3>基本情報</h3>
        <div class="item-confm-sec">
          <div class="itm-info-list">
            <label>氏名</label>
            <p>{{ formData.last_name }} {{ formData.full_name }}</p>
            <!-- <span>{{getPosition(formData.position)}}</span> -->
          </div>
          <div class="itm-info-list">
            <label>氏名（ふりがな）</label>
            <p>{{ formData.last_furigana }} {{ formData.furigana }}</p>
          </div>
          <div class="itm-info-list">
            <label>性別</label>
            <p>{{ formData.gender }}</p>
          </div>
          <div class="itm-info-list">
            <label>生年月日</label>
            <p>{{ birthDate }}</p>
          </div>
          <div class="itm-info-list">
            <label>居住地</label>
            <p>{{ getResidence(formData.residence) }}</p>
          </div>
 
          <!-- <div class="itm-info-list">
                <label>...</label>
                <p>{{formData.phone}}</p>
            </div> -->
        </div>
        <!-- ends item-confm-sec -->
      </div>
      <!-- ends form-sep-block -->
      <div class="form-sep-block">
        <h3>学歴</h3>
        <div class="item-confm-sec">
          <div class="itm-info-list">
            <label>最終学歴</label>
            <p>{{ getFinalEducation(formData.final_education) }}</p>
          </div>
          <div class="itm-info-list">
            <label>卒業学校名</label>
            <p>{{ formData.graduation_school_name }}</p>
          </div>
          <div class="itm-info-list">
            <label>卒業学部名</label>
            <p>{{ formData.graduation_department_name }}</p>
          </div>
          <div class="itm-info-list">
            <label>卒業年月</label>
            <p>
              {{ formData.year_of_graduation }} 年
              <span>{{ formData.month_of_graduation }} 月</span>
            </p>
          </div>
        </div>
        <!-- ends item-confm-sec -->
      </div>
      <!-- ends form-sep-block -->
      <div class="form-sep-block">
        <h3>職歴</h3>
        <div class="item-confm-sec">
          <div class="itm-info-list">
            <label>直近在籍企業名</label>
            <p>{{ formData.recent_registered_company_name }}</p>
          </div>
          <div class="itm-info-list">
            <label>在籍期間</label>
            <div>
              <p v-if="formData.currently_enrolled">在籍中</p>
              <div class="enrollment_period">
                <div class="d-inline-flex flex-basis-100">
                  <span>{{ enrollment_period.from.year }}</span>
                  <label>年</label>
                  <span>{{ enrollment_period.from.month }}</span>
                  <label>月</label>
                </div>
                <label class="d-inline-flex align-items-center tilt">~</label>
                <div
                  class="d-inline-flex flex-basis-100"
                  v-if="enrollment_period.to.year"
                >
                  <span>{{ enrollment_period.to.year }}</span>
                  <label>年</label>

                  <span>{{ enrollment_period.to.month }}</span>
                  <label>月</label>
                </div>
              </div>
            </div>
            <p>{{ formData.years_of_attendance }}</p>
          </div>
          <div class="itm-info-list">
            <label>直近職種</label>
            <p>
              {{ getMainOccupation(formData.latest_occupation_main_title) }}
              ({{
                getChildOccupation(
                  formData.latest_occupation_main_title,
                  formData.latest_occupation_sub_title
                )
              }})
            </p>
          </div>
          <div class="itm-info-list">
            <label>雇用形態</label>
            <p>{{ getStatus(formData.employment_status) }}</p>
          </div>
          <div class="itm-info-list">
            <label>役職</label>
            <p>{{ getPosition(formData.position) }}</p>
          </div>
          <div class="itm-info-list">
            <label>英語力</label>
            <p>{{ getEnglishSkill(formData.english_skills) }}</p>
          </div>
          <div class="itm-info-list">
            <label>直近年収（万円）</label>
            <p>{{ formData.last_year_income }}</p>
          </div>
          <div class="itm-info-list">
            <label>これまでの経験社数</label>
            <p>{{ formData.number_of_experience_companies }}</p>
          </div>
          <div class="itm-info-list" style="max-width: 80vw">
            <label>職務経歴書</label>
            <p class="resumeFile">{{ formData.resume_file_name }}</p>
          </div>
          <div class="itm-info-list">
            <label>職務要約</label>
            <p style="word-break: break-word; white-space: pre-line;">
              {{ formData.job_summary }}
            </p>
          </div>
          <!-- <div class="itm-info-list">
                <label>転職に関する現時点での意向</label>
                <p style="word-break: break-word;">{{getScreeningIntention(formData.screening_intention)}}</p>
            </div> -->
          <div class="itm-info-list">
            <label>配慮事項について</label>
            <p style="word-break: break-word; white-space: pre-line;">
              {{ formData.career_change_reason }}
            </p>
          </div>
        </div>
        <!-- ends item-confm-sec -->
      </div>

      <div class="form-sep-block">
        <h3>アカウント情報</h3>
        <div class="item-confm-sec">
          <div class="itm-info-list">
            <label>メールアドレス</label>
            <p>{{ formData.email }}</p>
          </div>
          <div class="itm-info-list">
            <label>パスワード</label>
            <p>{{ '*'.repeat(formData.password ? formData.password.length : 0) }}</p>
          </div>
        </div>
      </div>
      <!-- ends form-sep-block -->
    </div>
    <!-- ends form-wrap -->
    <div class="bloom-terms-sec">
      <div class="bloom-terms">
        <h4>Bloomキャリア登録ユーザー利用規約</h4>
        <div class="bloom-terms-dtl" ref="termsContent" @scroll="checkScrollPosition">
          <TermsLists/>
        </div>
      </div>
      <div class="bloom-prec">
        <h4>注意事項</h4>
        <div class="bloom-prec-dtl">
          <ul>
            <li>
              キャリア登録はご登録いただいた全ての方に選考の機会やポジション案内をお約束するものではありません。
            </li>
            <li>
              登録情報の有効期限は、登録日または最終ログイン日より１年間です。登録情報はマイページから変更でき、
              <br />
              最新の情報が登録先企業に対して公開されます。
            </li>
            <li>
              Bloomキャリア登録は株式会社Bloomが運営しています。登録情報は株式会社Bloomおよび登録先企業で閲覧・利用できるものとします。
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="proceed-block">
      <div
        class="btn-toolbar btn-rg align-items-center flex-column"
        role="toolbar"
        aria-label="Toolbar with button groups"
      >
        <button
          class="btn btn-cstm btn-cstm-primary w-100 mw-294 mb-3 d-block register"
          v-on:click.prevent="register()"
          style="background: #EB0A1E; border-color: #EB0A1E;"
          :disabled="submitting || !termsScrolled"
        >
          <span class="d-flex justify-content-center agreement-text">
            利用規約・注意事項に同意して
          </span>
          <span class="d-flex justify-content-center register-text">
            登録する
          </span>
        </button>
        <button
          class="btn btn-cstm btn-cstm-outline-primary w-100 mw-294"
          v-on:click.prevent="cancel()"
        >
          修正する
        </button>
      </div>
      <p>
        <a href="https://www.blm.co.jp/" target="_blank">© Bloom Inc.</a>
      </p>
    </div>
    <!-- ends proceed-block -->

    <!-- Commented By krishna  -->
    <!-- <table class="table">
        <tbody>
        <tr>
            <th>勤務地、担当業務などにおいて、今後ご転職された場合に叶えたいこと、こだわり等あればお聞かせください。</th>
            <td style="word-break: break-word; white-space: pre-line;"><p>{{formData.career_change_reason}}</p></td>
        </tr>
        <tr>
            <th>職務経歴書の作成状況についてお聞かせください。</th>
            <td style="word-break: break-word;">
            {{getJobHistoryRecord(formData.job_history_record)}}
            </td>
        </tr>
        </tbody>
        </table> -->
    <!-- Commented By krishna  -->
  </form>
</template>

<script>
/* eslint-disable */

import moment from 'moment';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Api from '../config/api';
import TermsLists from './TermsLists.vue';

export default {
  name: 'BProfilePreview',
  components: { TermsLists },
  props: {
    registrationEndpoint: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      termsScrolled: false,
      // imageData: '',
      registered: false,
      checked: false,
      fileData: '',
      submitting: false,
    };
  },
  computed: {
    ...mapGetters({
      data: 'getData',
      formData: 'getFormData',
      serverErrors: 'getServerErrors',
      companyData: 'getCompanyData',
    }),
    styleHeader() {
      return this.companyData.brand_primary_color
        ? { background: this.companyData.brand_primary_color }
        : { background: '#000000' };
    },
    styleButton() {
      return this.companyData.brand_secondary_color
        ? {
            background: this.companyData.brand_secondary_color,
            'border-color': this.companyData.brand_secondary_color,
          }
        : {
            background: '#000000',
            'border-color': '#000000',
          };
    },
    birthDate() {
      return moment(this.formData.birth_date).format('YYYY/MM/DD');
    },
    enrollment_period() {
      const [fromYear, fromMonth] = this.formData.enrollment_period_from.split(
        '/'
      );
      let enrolled = {
        from: {
          year: fromYear,
          month: fromMonth,
        },
        to: {
          year: '',
          month: '',
        },
      };

      if (!this.formData.currently_enrolled) {
        const [toYear, toMonth] = this.formData.enrollment_period_to.split('/');
        enrolled.to.year = toYear;
        enrolled.to.month = toMonth;
      }
      return enrolled;
    },
  },
  methods: {
    ...mapMutations({
      setServerErrors: 'setServerErrors',
      clear: 'clear',
    }),
    ...mapActions({
      setData: 'setData',
      checkCompany: 'checkCompany',
      setRegEmail: 'setRegEmail',
      setRegCompany: 'setRegCompany',
    }),
    checkScrollPosition() {
      if(this.termsScrolled) return
      const termsContent = this.$refs.termsContent
      if (!termsContent) return
      
      // Check if user has scrolled to bottom (with small tolerance)
      const isAtBottom = termsContent.scrollTop + termsContent.clientHeight >= termsContent.scrollHeight - 10
      
      
      this.termsScrolled = isAtBottom
    },
    cancel() {
      this.$emit('redirectToRegistrationPage');
      //   this.$router.push({
      //     name: "registration",
      //     params: { slug: this.$route.params.slug },
      //   });
    },
    getFinalEducation(id) {
      if (this.data.finalEducation) {
        const result = this.data.finalEducation.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getResidence(id) {
      if (this.data.residence) {
        const result = this.data.residence.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getStatus(id) {
      if (this.data.status) {
        const result = this.data.status.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getEnglishSkill(id) {
      if (this.data.englishSkill) {
        const result = this.data.englishSkill.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getPosition(id) {
      if (this.data.position) {
        const result = this.data.position.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getScreeningIntention(id) {
      if (this.data.screeningIntention) {
        const result = this.data.screeningIntention.find(
          ({ _id }) => _id === id
        );
        if (result) return result.title;
      }
      return '';
    },
    getJobHistoryRecord(id) {
      if (this.data.jobHistoryRecord) {
        const result = this.data.jobHistoryRecord.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getMainOccupation(id) {
      if (this.data.latestOccupation) {
        const result = this.data.latestOccupation.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return '';
    },
    getChildOccupation(parentId, childId) {
      const parent = this.data.latestOccupation.find(
        ({ _id }) => _id === parentId
      );
      if (parent) {
        const result = parent.children.find(({ _id }) => _id === childId);
        if (result) return result.title;
      }
      return '';
    },
    async register() {
      try {
        this.submitting = true;
        const dataform = new FormData();
        Object.keys(this.formData).forEach((key) => {
          if (key !== 'resume_selectedFile' && key !== 'resume_file_name') {
            dataform.append(key, this.formData[key]);
          }
        });
        // if (this.imageData) {
        //   dataform.append('image', this.formData.selectedFile, this.formData.image_name);
        // }

        if (this.formData.resume_selectedFile !== '') {
          dataform.append(
            'resume',
            this.formData.resume_selectedFile,
            this.formData.resume_file_name
          );
        }
        let reg = await this.axios({
          method: 'post',
          data: dataform,
          url: Api.url(Api.endpoints[this.registrationEndpoint]),
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        this.setRegEmail(reg.data.data.email);
        this.clear();
        console.log(this.registrationEndpoint);
        if (this.registrationEndpoint === 'Register') {
          try {
            const compRes = await this.axios({
              method: 'get',
              url: Api.url(
                `${Api.endpoints.CheckCompanyExists}/${this.$route.params.slug}`
              ),
            });
            const companyData = compRes.data.data;
            this.setRegCompany(companyData.companyNameTitle);
          } catch (e) {
            console.log(e);
            this.setRegCompany(this.$route.params.slug);
          }
        }
        this.submitting = false;
        this.$router.push({ name: 'thankyou' });
      } catch (error) {
        if (error.response.status === 422) {
          this.setServerErrors(error.response.data);
          this.$emit('redirectToRegistrationPage');
          //   this.$router.push({
          //     name: "registration",
          //     params: { slug: this.$route.params.slug },
          //   });
        } else if (error.response.status === 503) {
          this.$router.push({ name: 'Maintenance' });
        } else {
          await swal({
            text: `システムエラーが発生しています。
            大変申し訳ありませんが、時間をおいて再度実施いただくか、以下までご連絡ください。
            よろしくお願い申し上げます。
            キャリア登録運営事務局 info@blm.co.jp`,
            icon: 'error',
            buttons: {
              ok: 'はい',
            },
          });
        }
        this.submitting = false;
      }
    },
    // photoPreview() {
    //   if (this.formData.selectedFile) {
    //     // create a new FileReader to read this image and convert to base64 format
    //     const reader = new FileReader();
    //     // Define a callback function to run, when FileReader finishes its job
    //     reader.onload = (e) => {
    //       // Note: arrow function used here, so that "this.imageData" refers to the imageData
    //       // of Vue component
    //       // Read image as base64 and set to imageData
    //       this.imageData = e.target.result;
    //     };
    //     // Start the reader job - read file as a data url (base64 format)
    //     reader.readAsDataURL(this.formData.selectedFile);
    //   }
    // },
    scrollToTop() {
      const element = document.getElementsByClassName('main-wrapper')[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  // mounted() {
  //   this.scrollToTop();
  // }
};
</script>
<style scoped>
.resumeFile {
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre;
}

.enrollment_period > div {
  align-items: center;
  margin-top: 5px;
}

.enrollment_period span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  font-size: 16px;
  font-weight: 400;
}

.enrollment_period label {
  margin-right: 10px;
}

.enrollment_period .tilt {
  font-size: 20px;
}

.flex-basis-100 {
  flex-basis: 100%;
}

@media only screen and (max-width: 461px) {
  .enrollment_period {
    flex-wrap: wrap;
  }

  .enrollment_period .tilt {
    flex-basis: 100%;
    /* margin-left: 58px; */
  }
}

.register {
  height: fit-content;
}

.agreement-text {
  font-size: 13px;
  color: #eee;
  font-weight: 500;
}

.register-text {
  font-size: 20px;
}

.profile-head {
  padding: 15px 35px;
}
.profile-head h2 {
  cursor: default;
}
@media (max-width: 576px) {
  .profile-head h2 {
    font-size: 20px;
  }
}
p {
  line-height: 18px;
}
</style>
